import { MatButtonModule } from '@angular/material/button';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatIconRegistry } from '@angular/material/icon';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DesignSystemDocsContentModule } from '@ui/design-system-docs/content';
import { IntroComponent } from '../../../../libs/design-system-docs/content/src/lib/intro/intro.component';
import {
  AmIconModule,
  AmLayoutModule,
  AppNavModule,
  matDialogDefaultOptions,
  matFormFieldDefaultOptions,
} from '@armor/material';

import { AppComponent } from './app.component';
import { ExtraOptions, RouterModule } from '@angular/router';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    DesignSystemDocsContentModule,
    AmIconModule,
    RouterModule.forRoot(
      [
        { path: '', component: IntroComponent },
        {
          path: 'components',
          loadChildren: () =>
            import(
              '../../../../libs/design-system-docs/feature-component-docs/src/lib/design-system-docs-feature-component-docs.module'
            ).then((m) => m.DesignSystemDocsFeatureComponentDocsModule),
        },
        {
          path: 'design',
          loadChildren: () =>
            import(
              '../../../../libs/design-system-docs/design-docs/src/lib/design-docs.module'
            ).then((m) => m.DesignDocsModule),
        },
        {
          path: 'develop',
          loadChildren: () =>
            import(
              '../../../../libs/design-system-docs/developer-docs/src/lib/developer-docs.module'
            ).then((m) => m.DeveloperDocsModule),
        },
      ],
      {
        initialNavigation: 'enabled',
        relativeLinkResolution: 'legacy',
      }
    ),
    AppNavModule,
    AmLayoutModule,
    MatButtonModule,
    MatTooltipModule,
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: matFormFieldDefaultOptions,
    },
    {
      provide: MAT_TABS_CONFIG,
      useValue: matDialogDefaultOptions,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(iconRegistry: MatIconRegistry) {
    iconRegistry.setDefaultFontSetClass('ti');
  }
}
